import { toggleElements } from './searchModalUtils.js';

const addModalEventListeners = (modal, elementsToHide) => {
    if (!modal) {
        return;
    }

    modal.addEventListener('shown.bs.modal', () => {
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => {
            backdrop.remove();
        });
    });

    modal.addEventListener('hidden.bs.modal', () => {
        toggleElements(elementsToHide, 'show');
    });
}

export { addModalEventListeners };


